import { requestProductContractGroupById } from './actions';

export const DEFAULT_PRODUCT_CONTRACT_GROUPS_STATE = {
  data: []
};

const normalize = (state, productContractGroups) => ({
  ...state,
  productContractGroups
});

const productContractGroupsReducer = (state, action) => {
  const { productContractGroups } = state;

  switch (action.type) {
    case 'FETCH_ALL_PRODUCT_CONTRACT_GROUPS_SUCCESS':
      return normalize(state, {
        ...DEFAULT_PRODUCT_CONTRACT_GROUPS_STATE,
        data: action.payload.contractGroups
      });

    case requestProductContractGroupById.event.success: {
      const [group] = action.payload;

      const idxToUpdate = state.productContractGroups.data.findIndex(({ id }) => id === group.id);
      const isNewGroup = idxToUpdate === -1;

      const newState = normalize(state, {
        ...productContractGroups,
        data: [...productContractGroups.data, ...(isNewGroup ? [group] : [])]
      });

      if (!isNewGroup) newState.productContractGroups.data[idxToUpdate] = group;

      return newState;
    }

    default:
      return state;
  }
};

export default productContractGroupsReducer;
